import { render, staticRenderFns } from "./burger-button.vue?vue&type=template&id=60e2bfa2&"
import script from "./burger-button.vue?vue&type=script&lang=js&"
export * from "./burger-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports